import { render, staticRenderFns } from "./SpeedEdit.vue?vue&type=template&id=146882c8&"
import script from "./SpeedEdit.vue?vue&type=script&lang=ts&"
export * from "./SpeedEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports